import classes from "./RoundedButton.module.css";

const RoundedButton: React.FC<{
  label: string;
}> = (props) => {
  return (
    <div className={classes.wrapper}>
      <button type="submit" className={classes.button}>{props.label}</button>
    </div>
  );
};

export default RoundedButton;
